// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mouse-position[data-v-42222b56]{background-color:hsla(0,0%,98%,.4);margin-bottom:5px}@container (max-width: 800px){.mouse-position{font-size:2cqw}}", ""]);
// Exports
module.exports = exports;
